import {Container} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

export const GlobalLoad = () => {

	return <Container sx={{textAlign: 'center', mt: 6}}>
		<CircularProgress size={70}/>
	</Container>
}
